// extracted by mini-css-extract-plugin
export default {"tableIcon":"StudentTableIconWithIndicator_tableIcon__65Ucm","indicator":"StudentTableIconWithIndicator_indicator__SkEl8"};